import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=74670375&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74670375')) {
      api.createRecord('74670375', component.options)
    } else {
      api.reload('74670375', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=74670375&", function () {
      api.rerender('74670375', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/sidebar-menu/Item.vue"
export default component.exports